// SharedComponents/Layout.jsx
import { Outlet, useLocation } from "react-router-dom";
// import Breadcrumb from "./BreadCrumb";

const Layout = () => {
  const { pathname } = useLocation();
  const isPlaceDetailPage = /^\/places\/[^/]+$/.test(pathname);
  const isSearchResultsPage = pathname === "/search-results";
  const usesOwnTopSpacing =
    pathname === "/" ||
    pathname === "/about" ||
    pathname === "/login" ||
    pathname === "/signUp" ||
    pathname.startsWith("/place-contributions/") ||
    pathname.startsWith("/places/city/") ||
    isPlaceDetailPage ||
    isSearchResultsPage;

  return (
    <div className="">
      {/* <Breadcrumb /> */}
      {!usesOwnTopSpacing && <div className="hidden h-24 tablet:block" aria-hidden="true" />}
      <Outlet />
    </div>
  );
};

export default Layout;
